export default __webpack_public_path__ + "images/National-Trust.jpg";